/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 11/19/14
 * Time: 6:07 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Template = require("templates/userBarWidgets/topBarNotification.tmpl");
    var Bubble = require("ui/bubble/Bubble");
    var _ = require("underscore");
    var CONST = require("const");

    var CONFIG = {
        css: {
            iconActive: "topBarNotificationIcon-active"
        }
    };

    var TopBarNotificationView = Marionette.ItemView.extend({
        template: Template,
        withUIComponents: true,
        events: {
            click: "_onClick"
        },
        ui:{
            icon:".topBarWidgetIcon"
        },
        modelEvents: {
            "change": "_onNotificationChange"
        },
        bubbleComponentId:"topBarNotificationBubble",

        onRender: function () {
            this._hide();
        },

        _onNotificationChange: function () {
            this._closeNotification();

            this.notificationObj = this.model.get("notification");
            if(this.notificationObj){
                this._notify();
            }
            else{
                this._hide();
            }

        },
        _notify:function(){
            this._show();
            this._showNotification();
            if(this.notificationObj.onShow){
                this.notificationObj.onShow(this.notificationObj);
            }

        },
        _createAndRenderBubble: function () {
            var bubbleOptions = this._getBubbleOptions(this.notificationObj);
            this.uiComponents.host$.createAndRender(this.bubbleComponentId, {
                type: Bubble,
                options: bubbleOptions
            });
            setTimeout(_.bind(this._hideNotification,this), 5000);
        },

        _getBubbleOptions: function (notificationObj) {
            var bubbleOptions = {
                targetControl: this.ui.icon,
                showCloseButton: true,
                onBubbleClose: _.bind(this._onBubbleClose,this)
            };
            bubbleOptions = this._setBubbleContentOptions(notificationObj.contentOptions, bubbleOptions);
            bubbleOptions = this._setBubbleContentViewOptions(notificationObj.viewOptions, bubbleOptions);
            bubbleOptions = this._setBubbleUiOptions(notificationObj, bubbleOptions);
            return bubbleOptions;
        },
        _setBubbleContentOptions: function (contentOptions, bubbleOptions) {
            if (contentOptions) {
                bubbleOptions.title = contentOptions.title;
                bubbleOptions.text = contentOptions.text;
                bubbleOptions.buttonCaption = contentOptions.buttonCaption;
                bubbleOptions.buttonCallback = contentOptions.buttonCallback;
                bubbleOptions.buttonPermutation = contentOptions.buttonPermutation;
            }
            return bubbleOptions;
        },
        _setBubbleContentViewOptions: function (contentViewOptions, bubbleOptions) {
            if (contentViewOptions && contentViewOptions.getContentViewCallBack) {
                bubbleOptions.contentView = contentViewOptions.getContentViewCallBack();
            }
            return bubbleOptions;
        },
        _setBubbleUiOptions: function (notificationObj,bubbleOptions) {
            var icon;
            var permutation;
            switch (notificationObj.type) {
                case CONST.TOP_BAR_NOTIFICATION_TYPE.INFO:
                    icon = Bubble.ICON.WARNING_WHITE;
                    permutation = Bubble.PERMUTATION.B;
                    break;
                case CONST.TOP_BAR_NOTIFICATION_TYPE.SUCCESS:
                    icon = Bubble.ICON.SUCCESS;
                    permutation = Bubble.PERMUTATION.B;
                    break;
                case CONST.TOP_BAR_NOTIFICATION_TYPE.ERROR:
                    icon = Bubble.ICON.ERROR;
                    permutation = Bubble.PERMUTATION.B;
                    break;
                case CONST.TOP_BAR_NOTIFICATION_TYPE.PROGRESS:
                    icon = Bubble.ICON.PROGRESS;
                    permutation = Bubble.PERMUTATION.B;
                    break;
                default:
                    icon = Bubble.ICON.WARNING_WHITE;
                    permutation = Bubble.PERMUTATION.B;
                    break;
            }
            bubbleOptions.icon= icon;
            bubbleOptions.permutation= permutation;
            return bubbleOptions;
        },
        _closeNotification:function(){
            this._hideNotification();
            this._callNotificationOnClose();
        },
        _toggleIconActive: function (active) {
            if (active) {
                this.ui.icon.addClass(CONFIG.css.iconActive);
            } else {
                this.ui.icon.removeClass(CONFIG.css.iconActive);
            }
        },
        _showNotification: function () {
            this._toggleIconActive(true);
            this._createAndRenderBubble();
        },
        _hideNotification: function () {
            this._toggleIconActive(false);
            this._closeBubble();
        },
        _closeBubble: function () {
            if (this.uiComponents && this.uiComponents[this.bubbleComponentId]) {
                this.uiComponents[this.bubbleComponentId].close(true);
            }
        },
        _onClick: function () {
            this.notificationObj = this.notificationObj ||{};
            if(this.notificationObj.id){
                this._notify();
            }
        },
        _onBubbleClose:function(){
            this._toggleIconActive(false);
            this._callNotificationOnClose();
            if (_.has(this.notificationObj, "removeOnClose") && this.notificationObj.removeOnClose) {
                this.trigger("removeNotification", {id:this.notificationObj.id});
            }
        },
        _callNotificationOnClose: function () {
            this.notificationObj = this.notificationObj || {};
            if (this.notificationObj.onClose && _.isFunction(this.notificationObj.onClose)) {
                this.notificationObj.onClose(this.notificationObj);
            }
        },
        _hide:function(){
            this.$el.hide();
        },
        _show:function(){
            this.$el.show();
        }


    });
    return TopBarNotificationView;
});

